import { Component, computed, inject } from '@angular/core';
import { CenterStore } from '../../../../stores/center/center.store';
import { Router } from '@angular/router';
import { CenterService, CenterUserService } from '@malirang/api-client';
import { CenterRoleStore } from 'apps/client/src/stores/center/role.store';
import { CenterUserStore } from 'apps/client/src/stores/center/user.store';

@Component({
  selector: 'app-center-page-adapter',
  template: '',
})
export class CenterPageAdapter {
  readonly centerService = inject(CenterService);
  readonly centerUserService = inject(CenterUserService);
  readonly store = inject(CenterStore);
  readonly roleStore = inject(CenterRoleStore);
  readonly centerUserStore = inject(CenterUserStore);
  readonly router = inject(Router);
  center = this.store.currentCenter;
  centerId = this.store.currentCenterId;
}
